import { defineComponent as h, useCssModule as v, useAttrs as g, computed as a, openBlock as l, createElementBlock as n, mergeProps as i, unref as c, renderSlot as y, normalizeProps as b, createCommentVNode as w } from "vue";
import z from "../../utils/mapClasses.mjs";
import { responsiveModifyClass as k } from "../../utils/buildClass.mjs";
import x from "../../utils/propValidator.mjs";
const o = "cdr-icon", I = /* @__PURE__ */ h({
  name: "CdrIcon",
  __name: "CdrIcon",
  props: {
    /**
    * Only on CdrIcon. Sets the href attribute for use with SVG symbol sprite (see @rei/cedar-icons).
    */
    use: String,
    /**
     * Sets icon fill to "inherit" so as to use parent/ancestor fill color.
     */
    inheritColor: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: void 0,
      validator: (s) => x(s, ["small", "large"])
    }
  },
  setup(s) {
    const e = s, d = v(), r = g(), u = !r["aria-label"] && !r["aria-labelledby"], m = a(() => e.inheritColor ? `${o}--inherit-color` : ""), p = a(() => e.size ? k(o, "", e.size) : ""), t = {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      "aria-hidden": void 0
    };
    u && (t["aria-hidden"] = "true");
    const f = {
      href: e.use,
      "xlink:href": e.use
    };
    return (C, B) => (l(), n("svg", i(t, {
      class: c(z)(c(d), o, p.value, m.value)
    }), [y(C.$slots, "default"), s.use ? (l(), n("use", b(i({
      key: 0
    }, f)), null, 16)) : w("", !0)], 16));
  }
});
export {
  I as default
};
